import type {
  NotificationStatus,
  NotificationSuppressReason,
  PushCategory,
  PushMailMode,
} from '../contracts/notifications';
import type { ApprovalPushMode } from '../enums';

export const NOTIFICATION_STATUS_LABELS: Record<NotificationStatus, string> = {
  queued: 'W kolejce',
  sent: 'Wysłane',
  suppressed: 'Pominięte',
  failed: 'Błąd',
};

export const NOTIFICATION_SUPPRESS_REASON_LABELS: Record<NotificationSuppressReason, string> = {
  push_disabled: 'Powiadomienia wyłączone',
  severity: 'Ta ważność nie wysyła powiadomień',
  setting_off: 'Wyłączone w ustawieniach',
  low_priority: 'Tylko akceptacje o wysokim priorytecie',
  no_subscription: 'Brak urządzenia z włączonymi powiadomieniami',
  quiet_hours: 'Godziny ciszy',
  inbox_done: 'Już zrobione w Inboxie',
  no_access: 'Brak dostępu do rekordu',
  inbox_read: 'Już przeczytane w Inboxie',
  inbox_snoozed: 'Odłożone w Inboxie',
  resolved: 'Już rozstrzygnięte',
  burst: 'Seria: powiadomienie wysłane niedawno',
  not_configured: 'Powiadomienia wyłączone — brak konfiguracji',
  send_failed: 'Nie udało się wysłać',
  simulated: 'Symulacja — nic nie zostało wysłane',
  imported: 'Poczta z historii skrzynki — bez powiadomień',
};

/** Brak adaptera albo klucza VAPID w tej instalacji (Ustawienia → Powiadomienia, próbne powiadomienie). */
export const PUSH_UNAVAILABLE_MESSAGE = 'Powiadomienia wyłączone — brak konfiguracji';
/** Wysyłka przez adapter fake (wynik próbnego powiadomienia, dziennik `notifications`). */
export const PUSH_SIMULATION_NOTE = 'Symulacja — nic nie zostało wysłane';

/** Ustawienia → Powiadomienia: „Akceptacje na telefonie”. */
export const APPROVAL_PUSH_MODE_LABELS: Record<ApprovalPushMode, string> = {
  never: 'Nigdy',
  high: 'Tylko wysoki priorytet',
  always: 'Zawsze',
};

/**
 * Podpowiedź przy „Akceptacje” (Ustawienia → Powiadomienia): opisuje, kto dziś nadaje wysoki priorytet
 * (akcja wygasająca w ciągu 12 h — zadanie `approvals.priority`; przypomnienie o płatności po terminie —
 * `renewalEmailPriority` w `contracts/maintenance`). Faktury i zwykłe maile mają priorytet normalny.
 * Przy nowym typie z wysokim priorytetem zaktualizuj tekst.
 */
export const APPROVAL_PUSH_HINT =
  'Akcje czekające na Twoją decyzję. Wysoki priorytet mają akcje, które wygasają w ciągu 12 godzin, i przypomnienia o płatności po terminie. Przy „Tylko wysoki priorytet” faktury i zwykłe maile czekają w Akceptacjach bez powiadomienia.';

/** Ustawienia → Powiadomienia: kategorie push zdarzeń „Zwykłe” (17.10.2026, domyślnie włączone). */
export const PUSH_CATEGORY_LABELS: Record<PushCategory, string> = {
  mail: 'Nowa poczta',
  tasks: 'Zadania przypisane do mnie i komentarze',
  clientRequests: 'Zgłoszenia od klientów',
};

/** Ustawienia → Powiadomienia → „Nowa poczta” (17.10.2026): tryb push poczty. */
export const PUSH_MAIL_MODE_LABELS: Record<PushMailMode, string> = {
  important: 'Istotne',
  all: 'Wszystkie',
  off: 'Wyłączone',
};

export const PUSH_MAIL_MODE_HINTS: Record<PushMailMode, string> = {
  important: 'Tylko maile, które wymagają Twojej uwagi. Newslettery i powiadomienia systemów — bez powiadomienia.',
  all: 'Każdy nowy mail w Twoim Inboxie, także mniej ważny.',
  off: 'Bez powiadomień o poczcie. Pilne alarmy przychodzą nadal.',
};

/** Podpowiedź pod kategoriami: godziny ciszy odkładają te powiadomienia (bez przełamywania). */
export const PUSH_CATEGORY_HINT =
  'Powiadomienie przychodzi, gdy coś trafi do Twojego Inboxu. W godzinach ciszy czeka do ich końca.';
